import {
  loginEmailAndPassword,
  refreshToken,
} from '@school_ify/schoolify-repository/src/public/repositories/authenticationRepository';
import {
  currentUser,
  resetPassword,
} from '@school_ify/schoolify-repository/src/shared/repositories/authenticationRepository';
import { LoginEmailAndPasswordMutationVariables } from '@school_ify/schoolify-repository/src/public/types';
import { UserFragment } from '@school_ify/schoolify-repository/src/shared/types';
import { resetApolloStore, updateToken } from '@school_ify/schoolify-repository/src/client';

class AuthService {
  public async login(
    credentials: LoginEmailAndPasswordMutationVariables
  ): Promise<Readonly<UserFragment>> {
    try {
      const response = await loginEmailAndPassword(credentials);
      localStorage.setItem('token', response.jwt_token);
      localStorage.setItem('refresh_token', response.refresh_token);
      // @ts-ignore
      if (response.directus_login) {
        // @ts-ignore
        localStorage.setItem('directus_login', response.directus_login);
      }
      const user = await currentUser();
      localStorage.setItem('user', JSON.stringify(user));
      return user;
    } catch (err) {
      throw new Error(err);
    }
  }

  public async logout() {
    localStorage.clear();
    resetApolloStore();
  }

  public async SignUpCheckForUser() {
    try {
      await updateToken();
      const user = await currentUser();
      return user;
    } catch (err) {
      return err;
    }
  }

  public async PasswordSignUp(password: string) {
    const data = {
      new_password: password,
      old_password: password,
    };
    try {
      await resetPassword(data);
    } catch (err) {
      throw new Error(`Password sign up error: ${err}`);
    }
  }

  public async updateTokenOnLocal() {
    try {
      const refresh_token = localStorage.getItem('refresh_token');
      const session = await refreshToken({ refresh_token });
      localStorage.setItem('token', session.jwt_token);
      localStorage.setItem('refresh_token', session.refresh_token);
      return session.jwt_token;
    } catch (err) {
      this.logout();
      return err;
    }
  }

  public async getMe() {
    try {
      const user = await currentUser();
      localStorage.setItem('user', JSON.stringify(user));
      return user;
    } catch (err) {
      return err;
    }
  }
}

export default new AuthService();
